export default __webpack_public_path__ + "static/media/gb-eng.8ef6bd9e.svg";